import React from 'react';
import snakeToCapitalize from '@utils/functions/snakeToCapitalize';
import { translate } from '@utils/i18n';
import isValidDate from '@features/ActivityFeed/utils/isValidDate';
import { VersionEvent } from '../../../types';
import GeneralDetailChange from '../../GeneralDetailChange';
export default function createDefaultDetailStrategy() {
    return {
        appliesTo: () => true, // Chosen if no other specific strategy applies
        render: (key, newValue, oldValue, versionEvent) => {
            if (versionEvent === VersionEvent.Create) {
                let displayValueElement;
                if (typeof newValue === 'boolean') {
                    displayValueElement = newValue ? (React.createElement("span", null, translate('enabled', { namespace: 'features.commons' }))) : (React.createElement("span", null, translate('disabled', { namespace: 'features.commons' })));
                }
                else if (typeof newValue === 'string' && isValidDate(newValue)) {
                    displayValueElement = React.createElement("b", null, new Date(newValue).toLocaleString());
                }
                else {
                    displayValueElement = React.createElement("b", null, (newValue === null || newValue === void 0 ? void 0 : newValue.toString()) || '--');
                }
                return (React.createElement("span", { key: key },
                    snakeToCapitalize(key),
                    ": ",
                    displayValueElement));
            }
            return React.createElement(GeneralDetailChange, { key: key, labelKey: key, oldValue: oldValue, newValue: newValue });
        }
    };
}
